export default {

  heads: {
    homePage: '首页',
    certificates: '产品认证',
    ourservices: '我们的服务',
    newstrends: '新闻动态',
    companyIntroduction: '公司介绍',
    reportQuery: '报告查询',
    contactUs: '联系我们',
    lithiumBattery: 'FCC认证',
    ceCertificate: 'CE认证',
    pseCertificate: 'PSE认证',
    kcCertificate: 'ROHS认证',
    cccCertificate: 'UL认证'
  },
  whyChooseUs:{
    hardware:"硬件实力强",
    content11:"标准化实验室",
    content12:"强大的仪器平台和数据库",
    profession:"行业认可",
    content21:"与行业内多家公司合作",
    content22:"在业内有良好的口碑",
    talents:"高素质人才",
    content31:"拥有大量高素质人才",
    content32:"帮助企业快速准确解决问题",
    services:"服务周到",
    content41:"提供专人服务",
    content42:"服务网络遍布多个城市",
    contactUsh1:"您身边的检测专家",
    contactUsh3:"7x24小时提供优质的检测服务",
    contentButton:"联系我们"
  },
  serviceMsg:{
    customerTitle:"我们的服务",
    customerContentTi11:"安规检测",
    customerContent12:"安规测试是对电子产品在正常使用时可能带来的危险进行评估和验证的过程。它主要包括对电击、火灾、机械危险、化学危险等方面的测试和评估，以确保产品对用户和环境的安全性。",
    customerContentTi21:"RF检测",
    customerContent22:"无线射频（RF）检测通过无线电和电子通讯设备检测，确保设备对无线频谱的有效使用，不会干扰到其他用户使用无线频谱。通常还需要进行其他检测，以验证您的设备符合当地的电磁兼容性电气安全以及无线射频暴露的法规要求。",
    customerContentTi31:"EMC检测",
    customerContent32:"EMC测试又叫作电磁兼容（EMC）测试，指的是对电子产品在电磁场方面干扰大小（EMI）和抗干扰能力（EMS）的综合评定，是产品质量最重要的指标之一，电磁兼容的测量系统由测试场地和测试仪器组成。",
    customerContentTi41:"CE认证",
    customerContent42:"“CE”标志是一种安全认证标志，被视为制造商打开并进入欧洲市场的护照。在欧盟市场“CE”标志属强制性认证标志，不论是欧盟内部企业生产的产品，还是其他国家生产的产品，要想在欧盟市场上自由流通，就必须加贴“CE”标志。",
    customerContentTi51:"锂电池KC认证",
    customerContent52:"KC认证，是为了使消费者能更清楚地了解所购买的产品上标示的认证标志，以及减轻产品生产厂家负担的各种认证费用，韩国技术标准院（KATS）2008年8月20日宣布于2009年1月1日开始实行新的认证系统。",
    customerContentTi61:"PSE认证",
    customerContent62:"PSE认证是日本强制性安全认证，用以证明电机电子产品已通过日本电气和原料安全法 (DENAN Law) 或国际IEC标准的安全标准测试。规定，498种产品中，165种A类产品应取得菱形的PSE标志，333种B类产品应取得圆形PSE标志。",
    customerContentTi71:"FCC认证",
    customerContent72:"FCC认证中文为美国联邦通信委员会，直接对国会负责。涉及美国、哥伦比亚以及美国所属地区为确保与生命财产有关的无线电和有线通信产品的安全性。许多无线电应用产品、通讯产品和数字产品要进入美国市场，都要求FCC的认可。",
    customerContentTi81:"UL认证",
    customerContent82:"UL认证是美国最具权威的民间机构，其专注于进行安全试验和鉴定。通过UL认证的产品表示已经经过严格的测试，符合UL制定的安全标准。UL认证是自愿性的，但在美国和加拿大市场，带有UL认证标志的产品在消费者中享有广泛认可。",
  },
  footerMsg:{
    companyName:"深圳市易博检测有限公司",
    address:"公司总部：深圳市龙岗区南湾街道新中泰南湾产业园D栋226号",
    emil:"邮箱",
    companyWecat:"公司微信",
  },
  companyMsg:{
    textCenter:"关于我们",
    p1:"易博检测有限公司（YIBO）作为国际权威的第三方检测认证服务的先行者，是一家集检测、检验、认证及技术服务为一体的综合性第三方机构，在深圳宝安、龙华区均设有分部，为世界各地企业提供一站式的解决方案。",
    p2:"易博检测（YIBO）作为第三方检测机构，致力于为客户提供全面、高效、可靠的检测服务，具备高精度的检测设备和专业的技术团队。采用国际先进的检测方法和技术，确保检测结果的准确性和可靠性。同时，我们还拥有完善的实验室设施和严格的质量管理体系，以确保我们的检测能力始终处于行业领先水平。服务范围广泛，涵盖了电子、机械等多个领域。我们秉持着“公正、科学、准确、高效”的服务宗旨，以客户满意为我们的成功。以“专业、创新、激情、未来”的发展理念为指引，致力于成为全球领先的第三方检测机构。我们相信，在我们共同的努力下，必将迎来更加美好的明天。",
    // p2:"易博（YIBO）实验室严格依照ISO/IEC17025质量管理体系要求运行，是中国合格评定国家认可委员会（CNAS）认可和中国计量认证（CMA）的实验室；同时也是中国质量认证中心（CQC）的合作实验室，完全具备出具第三方检测报告的资质。除此，YIBO还获得国际电工委员会电工产品合格测试与认证组织（IECEE）认可的NCB全球认证UL-CBTL实验室资质；同时，也是美国A2LA、美国FCC、美国消费者安全协会CPSC、亚马逊的第三方服务提供商、欧陆Eurofins、ITS天祥、加拿大ISED、德国TUV等国际权威机构的战略合作实验室，检测报告具有国际公信力。"
  },
  jobChance:{
    reportQuery:"报告查询",
    ID:"编号",
    placeholder:"请输入报告编号",
  },
  newList:{
    newList1:"越南官方(MOIT)于2023年5月23日发布新的能效产品列表，新增需符合能效要求的产品，并更新了部分产品的适用标准。实施日期为2025年4月1日，官方将在实施日期前发布提前自愿申请指南。",
    newList2:"欧亚经济委员会(EEC)更新了对应法规CU TR 004/2011和CU TR 020/2011的海关编码清单，此变化减少了对管控范围的误解和歧义，更新的海关编码清单实施日为2023年4月16日。",
    newList3:"印度官方(TEC)发布通知，将会话边界控制器等三类产品基本要求(ER)中的部分测试参数豁免至 2023 年 6 月 30 日。",
    newList4:"老挝官方(MTC)于2023年7月21日发布的第0416公告已于2023年8月4日生效，主要的变更为第2类 (Type 2) 产品证书的有效期从三年缩减成一年。",
    newList5:"新加坡官方(IMDA)宣布，自2024年7月31日起停止3G网络服务，并针对仅有3G功能的移动终端与不支持 VoLTE 功能的智能手机实施计划。",
  },
  softwareList:{
        certification:"产品认证",
        lithiumBattery:"FCC认证",
        ceCertificate:"CE认证",
        pseCertificate:"PSE认证",
        kcCertificate:"ROHS认证",
        cccCertificate:"UL认证"
  },
  cetemplate:{
    ceh33:"一、认证简介",
    cep31:"CE认证，即只限于产品不危及人类、动物和货品的安全方面的基本安全要求，而不是一般质量要求，协调指令只规定主要要求，一般指令要求是标准的任务。因此准确的含义是：CE标志是安全合格标志而非质量合格标志。\"CE”标志是一种安全认证标志，被视为制造商打开并进入欧洲市场的护照。CE代表欧洲统一（CONFORMITE EUROPEENNE）。",
    ceh3:"二、认证范围",
    cep1:"1、电源CE认证：通信电源、开关电源、充电器、显示器电源、LED电源、LCD电源、不间断电源UPS等;",
    cep2:"2、灯具CE认证：吊灯、轨道灯、庭院灯、手提灯、筒灯、LED路灯、灯串、台灯、LED射灯、LED球泡灯、格栅灯、水族灯、路灯、LED灯管、LED灯具、节能灯、T8灯管等;",
    cep3:"3、家电CE认证：风扇、电水壶、音响、电视机、鼠标、吸尘器等;",
    cep4:"4、电子CE认证： 耳塞、路由器、手机电池、激光笔、振动棒等;",
    cep5:"5、通讯类产品CE认证：电话机、有线电话无线主副机、传真机、电话答录机、数据机、数据介面卡及其他通讯产品;",
    cep6:"6、无线产品CE认证：蓝牙BT产品、平板电脑、无线键盘、无线鼠标、无线读写器、无线收发器、无线对讲机、无线麦克风、遥控器、无线网路装置、无线影像传送系统及其他低功率无线产品等;",
    cep7:"7、无线通讯类产品CE认证：2G手机、3G手机、3.5G手机、DECT手机(1.8G，1.9G频段)、无线对讲机等;",
    cep8:"8、机械CE认证：汽油机、电焊机、数控钻床、工具磨床、割草机、洗涤设备、推土机、升降机、打孔机、洗碗机、水处理设备、汽油发焊机、印刷机械、木工机械等。",
    ceh32:"三、认证检测标准",
    cep11:"安规: IT及音视频类：EN 62368-1；",
    cep12:"家电：EN 60335系列；",
    cep13:"灯具：EN 60598系列，EN 61347；",
    cep14:"电池： EN 62133-1, EN 62133-2；",
    cep15:"RF（无线射频）: ETSI EN 300 220, ETSI EN 300 330, ETSI EN 300 440, ETSI EN 300 328, ETSI EN 301 893, ETSI EN301 511, ETSI EN 303 413, ETSI  EN 303 417",
    cep16:"EMC（电磁兼容）: EN 55032, EN 55035, EN 55014-1, EN 55014-2, EN 55015, EN 55011, EN 61547, EN 50130-4, EN 61000-6-4, EN 61000-3-2, EN 61000-3-3",
  },
  cbtemplate:{
    cbh3:"一、认证简介",
    p1:"FCC全称是Federal Communications Commission，中文为美国联邦通信委员会。于1934年根据Communications Act建立，是美国政府的一个独立机构，直接对国会负责。涉及美国50多个州、哥伦比亚以及美国所属地区为确保与生命财产有关的无线电和有线通信产品的安全性，FCC的工程技术部负责委员会的技术支持，同时负责设备认可方面的事务。许多无线电应用产品、通讯产品和数字产品要进入美国市场，都要求FCC的认可。",
    cbh32:"二、认证范围",
    p121:"1、电源FCC认证：通讯电源、开关电源、充电器、显示器电源、LED电源、LCD电源、不间断电源UPS等;",
    p122:"2、灯具FCC认证：吊灯、轨道灯、庭院灯、手提灯、筒灯、LED路灯、灯串、台灯、LED射灯、LED球泡灯、路灯、LED灯管、LED灯具、节能灯、T8灯管等;",
    p123:"3、家电FCC认证：电扇、电水壶、音响、电视机、鼠标、吸尘器等;",
    p124:"4、电子FCC认证： 耳塞、路由器、手机电池、激光笔、振荡棒等;",
    p125:"5、通讯类产品FCC认证：电话机、有线电话无线主副机、传真机、电话答录机、数据机、数据介面卡及其他通讯产品;",
    p126:"6、无线通讯类产品FCC认证：2G手机、3G手机、3.5G手机、DECT手机(1.8G,1.9G频)、无线对讲机等;",
    cbh33:"三、认证检测标准",
    p13:"1、FCC PART15 C/E/F 意图辐射设备测验、FCC PART 18 工业、科学以及医学设备;",
    p23:"2、FCC PART 22 公共移动通讯服务、FCC PART 24 个人通讯服务;",
    p33:"3、FCC PART 25 卫星通讯服务、FCC PART 27 其他FCC无线通讯服务;",
    p44:"4、FCC PART 68 电信终端设备;"
  },
  psetemplate:{
    pseh3:"一、认证简介",
    p1:"PSE 认证是日本强制性安全认证，用以证明电机电子产品已通过日本电气和原料安全法(DENAN Law)或国际 IEC 标准的安全标准测试。日本的DENTORL法（电器装置和材料控制法）规定，498种产品进入日本市场必须通过安全认证。其中，165种A类产品应取得菱形的PSE标志，333种B类产品应取得圆形PSE标志。",
    pseh32:"二、认证范围",
    p21:"1、特定电气用品安全法规定的产品范围，例如有：直流电源装置，开关及插座，电热水器，电源线及插头，其它家用器具变压器（AC-AC 电源产品）等116个产品;",
    p22:"2、特定电气用品安全法以外的产品范围，例如有：电热毯，电蒸锅，电烫发器，荧光灯，台灯，装饰灯，广告灯，锂电池以及所有的LED灯泡灯和LED灯具等341个产品;",
    pseh33:"三、认证检测标准",
    p31:"电源:J 60950-1、J 62368-1、J 60065、J 62368-1、J 61347-1、J 61347-2-13;",
    p32:"终端产品:J 61558-1、J 60335-1、J 60745-1;",
    p33:"电池:JIS C 8712、JIS C 8715-1;",
  },
  rohstemplate:{
    rohsh3:"一、认证简介",
    p1:"ROHS是由欧盟立法制定的一项强制性标准，它的全称是《关于限制在电子电器设备中使用某些有害成分的指令》(Restriction of Hazardous Substances)，主要用于规范电子电气产品的材料及工艺标准，使之更加有利于人体健康及环境保护。",
    rohsh32:"二、认证范围",
    p12:"1.大型家用电器、小型家用电器",
    p22:"2.IT和通讯设备",
    p32:"3.消费性设备",
    p42:"4.照明设备",
    p52:"5.电子及电器工具",
    p62:"6.玩具、休闲和体育器材",
    p72:"7.医疗器材",
    p82:"8.包括工业监测和控制仪器在内的监控设备",
    p92:"9.自动贩卖机",
    p102:"10.不包含在上述类别当中的其他",
    rohsh33:"三、认证检测标准",
    p13:"RoHS 2.0(2011/65/EU)"
  },
  ultemplate:{
    ulh3:"一、认证简介",
    p1:"UL，全称为Underwriters Laboratories Inc.，是美国最具权威的民间机构，其专注于进行安全试验和鉴定。通过UL认证的产品表示已经经过严格的测试，符合UL制定的安全标准。虽然UL认证是自愿性的，但在美国和加拿大市场，带有UL认证标志的产品在消费者和购买单位中享有广泛认可。因此，UL认证不仅是消费者权益的保障，也是企业赢得市场信任的有效工具。",
    ulh32:"二、认证范围",
    p12:"1.电子电气产品：包括但不限于家用电器（如冰箱、洗衣机、微波炉）、电视机、计算机及周边设备、电源适配器、电线电缆等电子产品。",
    p22:"2.机械产品：包括工业机械、家用机械、汽车部件等机械制品，以及工业控制设备、仪器仪表等。",
    p32:"3.机电产品：涵盖了电气和机械的结合体，例如电动工具、电动汽车、机电一体化设备等。",
    p42:"4.医疗器械：如医用电子设备、医用影像设备、医用监护设备等医疗器械。",
    p52:"5.建筑和消防产品：包括防火门、灭火器、烟雾探测器等，用于提高建筑物安全性和消防防护的产品。",
    ulh33:"三、认证检测标准",
    p13:"UL 94：可燃性测试标准、UL 1642：锂电池安全标准、 UL 60950：信息技术设备安全标准、UL 1310：I类电源单元安全标准、UL 4200A：纽扣电池安全标准"
  },
  services:{
    title1:"安规检测",
    title2:"电池检测",
    title3:"EMC检测",
    title4:"RF检测",
  },
  servicesdeils:{

    titleh41: "二、检测标准",
    titleh42: "三、检测方式",
    titleth1: "类别",
    titleth2: "标准",

    title: "安规检测",
    serh4:"一、安规检测",
    serp1:"安规检测，也称为产品安全性测试，是对产品的安全性能进行测试和评估的过程。",
    sertd1:"信息技术设备:",
    sertd2:"IEC/EN60950-1, AS/NZS 60950-1, GB4943.1",
    sertd3:"家用电器:",
    sertd4:"IEC/EN 60335-1, AS/NZS 60335.1, GB 4706.1",
    sertd5:"音频/视频类产品:",
    sertd6:"IEC/EN60065, AS/NZS 60065, GB8898",
    sertd7:"灯具:",
    sertd8:"IEC/EN 60598-1, AS/NZS 60598.1、GB 7000.1,IEC/EN 60598系列, AS/NZS 60598系列, GB 7000系列",
    sertd9:"灯的控制器:",
    sertd10:"IEC/EN 61347-1, AS/NZS 61347.1、GB 19510.1、IEC/EN 61347系列, AS/NZS 61347系列、GB 19510系列",
    sertd11:"1、电气安全性测试",
    sertd12:"2、机械安全性测试",
    sertd13:"3、材料安全性测试",
    sertd14:"4、辐射和电磁兼容性测试",
    sertd15:"5、化学品安全性测试",
    sertd16:"6、环境安全性测试",
    sertd17:"7、标签和标志检查",

    title2: "电池检测",
    serh42:"一、电池检测",
    serp12:"电池检测主要对电子电气产品内部电池进行安全与性能检测， 消除电池在设计阶段存在的安全隐患。 对产品的性能、运输、误用或滥用等潜在危险做合格性检测，避免造成更大的损失。",
    sertd122:"IEC标准:",
    sertd22:"IEC 62133,IEC 60086,IEC 61960,IEC 62660,IEC 62619,IEC 62620",
    sertd32:"欧洲标准:",
    sertd42:"EN 62133,EN 60086,EN 61960,EN 62660,EN 62619",
    sertd52:"美国标准:",
    sertd62:"UL 1642,UL 2054,UL 2056,UL 2271,UL 2580",
    sertd72:"中国标准:",
    sertd82:"GB 31241,GB/T 35590,SJ/T 11796",
    sertd92:"日本标准:",
    sertd102:"JIS C8712,JIS C8714,Appendix 9",
    sertd112:"1、外观检测",
    sertd122t:"2、电压检测",
    sertd132:"3、内阻测试",
    sertd142:"4、容量测试",
    sertd152:"5、循环寿命测试",
    sertd162:"6、温度测试",
    sertd172:"7、安全性能测试",

    title3: "EMC检测",
    serh43:"一、EMC检测",
    serp13:"电磁兼容性测试（EMC测试）是一系列检测和评估的过程，旨在验证电子设备在电磁环境中是否具有稳定的性能，既不会产生干扰，也不会受到外部电磁干扰。",
    sertd133t:"信息技术/音视频:",
    sertd23:"CISPR 32,CISPR 35,EN 55032,EN 55035,FCC PART 15B",
    sertd33:"灯具:",
    sertd43:"CISPR 15,IEC 61547,EN 55015,EN 61547,FCC PART 15B,FCC PART 18",
    sertd53:"家电:",
    sertd63:"CISPR 14.1,IEC 61000-3-2,EN 55014-1,EN 61000-3-2,FCC PART 15B",
    sertd73:"通用标准:",
    sertd83:"IEC 61000-6-1，IEC 61000-6-2,EN 61000-6-1,EN 61000-6-2,FCC PART 15B",
    sertd93:"工业/科学/医疗: ",
    sertd103:"CISPR 11,EN 55011,EN 61000-4,FCC PART 18,AS CISPR 11",
    sertd113:"1、射频辐射测试",
    sertd123:"2、射频传导测试",
    sertd133:"3、射频灵敏度测试",
    sertd143:"4、电压传导测试",
    sertd153:"5、静电放电测试",
    sertd163:"6、增强耐受测试",
    sertd173:"7、敏感度测试",

    title4: "RF检测",
    serh44:"一、RF检测",
    serp14:"无线射频RF检测是对无线电波的发射和接收进行测试和认证的过程，主要包括无线电波的频率、功率、调制方式、信号特征等方面的测试。",
    sertd144t:"欧洲标准：",
    sertd24:"ETSI EN 300 220、ETSI EN 300 330、ETSI EN 300 440、ETSI EN 300 328、ETSI EN 301 357、ETSI EN 301 511、ETSI EN 301 489",
    sertd34:"美国/加拿大标准：",
    sertd44:"FCC PART 15C/15E、FCC PART 22/24/27、RSS 247/248/210/216/132/133/130/139/199",
    sertd54:"澳洲标准：",
    sertd64:"AS/NZS 4268、AS/CA S042.1、AS/CA S042.2、AS/CA S042.3、AS/CA S042.4",
    sertd74:"中国标准：",
    sertd84:"工信部无[2021]129号、工信部无[2002]353号、工信部无[2002]277号、工信部无[2005]423号",
    sertd94:"日本标准：",
    sertd104:"《无线电法规》",
    sertd114:"1、9kHz-40GHz 的全电波暗室，满足目前主流所有无线设施的杂散测试。",
    sertd124:"2、无线射频(RF)自动测试系统，全程自动化，减少测试时间及人为手动测试的误差。",
    sertd134:"",
    sertd144:"",
    sertd154:"",
    sertd164:"",
  },
  ContactUszh:{
    label:"姓名",
    label2:"邮箱",
    label3:"电话",
    label4:"内容",
    placeholder1:"请输入姓名",
    placeholder2:"请输入邮箱",
    placeholder3:"请输入电话",
    placeholder4:"请输入内容",
    placeholder5:"请输入报告编号",
    submit:"提交",
    message1:"姓名不能为空",
    message2:"电话号码不能为空",
    message3:"请输入正确的电话号码",
    message4:"邮箱地址不能为空",
    message5:"请输入正确的邮箱地址",
    message6:"内容不能为空",
    messageerror1:"查询编号不能为空",
    messageerror2:"查不到对应的报告或认证",
    messageerror3:"查不到对应的报告或认证",
    messageerror4:"提交失败,请检查是否正确填写信息",
    messageerror5:"提交成功",
    messageerror6:"提交失败,请检查是否正确填写",
  },
  titles:{
    titles1:"易博检测-首页",
    titles2:"易博检测-产品认证",
    titles3:"产品认证丨FCC认证",
    titles4:"产品认证丨PSE认证",
    titles5:"产品认证丨CE认证",
    titles6:"产品认证丨ROHS认证",
    titles7:"产品认证丨UL认证",
    titles8:"易博检测-我们的服务",
    titles9:"易博检测-新闻动态",
    titles10:"易博检测-公司介绍",
    titles11:"易博检测-报告查询",
    titles12:"易博检测-联系我们",
    titles13:"易博检测-我们的服务",
  }

}



// WEBPACK FOOTER //
// ./src/lang/zh.js